import moment from "moment";
import { isNonEmptyArray, isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";


export const filterTasksByType = (userTasks, types) => {
	const isReviewTask = ({ taskType }) => {
		return isNonEmptyString(taskType) && types.includes(taskType.toUpperCase());
	};

	return isNonEmptyArray(userTasks)
		? userTasks.filter(isReviewTask)
		: [];
};

export const filterAllUserTasks = userTasks => {
	return filterTasksByType(userTasks, [ "TEAM", "UNIT", "RESEARCH", "CERTIFICATION", "INFOREADY" ]);
};

export const filterUserReviewTasks = userTasks => {
	return filterTasksByType(userTasks, [ "TEAM", "UNIT", "RESEARCH" ]);
};

export const filterCertificationTasks = userTasks => {
	return filterTasksByType(userTasks, [ "CERTIFICATION" ]);
};

export const formatDate = (date, timezone, dateFormat) =>{
	if (moment(date).isValid()) {
		return moment(date).tz(timezone).format(dateFormat);
	}

	return date;
};

export const formatDisplayDate = (date, dateFormat) =>{
	if (moment(date).isValid()) {
		return moment(date).format(dateFormat);
	}

	return date;
};
